import {
    CLEAR_PROBABILITY,
    FETCH_PROBABILITY,
    LIST_PROBABILITY,
    LIST_PROBABILITY_TYPE
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {},
    probabilityTypes: [],
    manageResult: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PROBABILITY:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PROBABILITY:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        case LIST_PROBABILITY_TYPE:
            return {
                ...state,
                isLoading: false,
                probabilityTypes: payload.data
            };
        case CLEAR_PROBABILITY:
            return {
                ...init
            };
        default:
            return state;
    }
}
